import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";

export default function ContactCta() {
  return (
    <section className="w-full bg-primary-500 px-4 py-14 md:px-10 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <h2 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            有想补充的背景，或者发现词条有误？
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-background-100">
            我们接受公开来源的更正说明与补充线索。提交时请附上可查证的链接，核实后会在词条页标注修改时间。
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
          >
            提交更正说明
            <i className="ri-arrow-right-line" />
          </Link>
          <a
            href={`mailto:${siteConfig.email}`}
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-mail-line" />
            邮件联系
          </a>
        </div>
      </div>
    </section>
  );
}